export function createHTMLElement  (data: any) {
  const objectUrl = window.URL.createObjectURL(data);
  const element   = document.createElement('a');
  element.href = objectUrl;

  return element;
}

export function downloadFile (
  element: HTMLAnchorElement,
  fileName: string,
  fileType: string) {

  const fullFileName = `${fileName}.${fileType === 'xls' ? 'xlsx' : fileType}`
  element.download = fullFileName;

  document.body.appendChild(element);
  element.click();
  window.URL.revokeObjectURL(element.href);
  document.body.removeChild(element);
}
